export enum UserRoles {
	Admin = 'admin',
	RegionManager = 'regionManager',
}
